import createIcon from '../../createIcon';

/**
 * @component @name ClosedCaptionOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNSA1LjVWMTguNUg0LjVWNS41SDE5LjVaTTE5IDRINUMzLjg5IDQgMyA0LjkgMyA2VjE4QzMgMTkuMSAzLjg5IDIwIDUgMjBIMTlDMjAuMSAyMCAyMSAxOS4xIDIxIDE4VjZDMjEgNC45IDIwLjEgNCAxOSA0Wk0xMSAxMUg5LjVWMTAuNUg3LjVWMTMuNUg5LjVWMTNIMTFWMTRDMTEgMTQuNTUgMTAuNTUgMTUgMTAgMTVIN0M2LjQ1IDE1IDYgMTQuNTUgNiAxNFYxMEM2IDkuNDUgNi40NSA5IDcgOUgxMEMxMC41NSA5IDExIDkuNDUgMTEgMTBWMTFaTTE4IDExSDE2LjVWMTAuNUgxNC41VjEzLjVIMTYuNVYxM0gxOFYxNEMxOCAxNC41NSAxNy41NSAxNSAxNyAxNUgxNEMxMy40NSAxNSAxMyAxNC41NSAxMyAxNFYxMEMxMyA5LjQ1IDEzLjQ1IDkgMTQgOUgxN0MxNy41NSA5IDE4IDkuNDUgMTggMTBWMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ClosedCaptionOff = createIcon('ClosedCaptionOff', [
  [
    'path',
    {
      d: 'M19.5 5.5V18.5H4.5V5.5H19.5ZM19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.1 4 19 4ZM11 11H9.5V10.5H7.5V13.5H9.5V13H11V14C11 14.55 10.55 15 10 15H7C6.45 15 6 14.55 6 14V10C6 9.45 6.45 9 7 9H10C10.55 9 11 9.45 11 10V11ZM18 11H16.5V10.5H14.5V13.5H16.5V13H18V14C18 14.55 17.55 15 17 15H14C13.45 15 13 14.55 13 14V10C13 9.45 13.45 9 14 9H17C17.55 9 18 9.45 18 10V11Z',
      key: 'xoqy0c',
    },
  ],
]);

export default ClosedCaptionOff;
